import { Divider, Flex, Text, useDisclosure } from "@chakra-ui/react";
import { FormCheckBox, NumericFormInputGroup } from "../../../../../components/Forms";
import { SubLever } from "./index";
import { useTranslation } from "react-i18next";
import { ConfirmationDialog } from "../../../../../components/ConfirmationDialog";
import * as React from "react";
import { translateSubElementString } from "../../../../../utils";
import { VALIDATION_PATTERNS } from "../../../helpers";
import { SUB_LEVER_PARAMETERS } from "../../../helpers";

function Lever({ leverData, leverIndex, baseYear, register, errors, control, watch, setValue, clearErrors }) {
  const { t } = useTranslation("translation");
  const { name: leverName, subLevers, id: leverId } = { ...leverData };
  const selected = watch(`${leverId}selected`);
  const formValues = watch();

  const { isOpen: isConfirmDialogOpen, onOpen: onConfirmDialogOpen, onClose: onConfirmDialogClose } = useDisclosure();

  const clearLeverData = () => {
    setValue(`${leverId}totalCo2Emissions`, null);
    clearErrors(`${leverId}totalCo2Emissions`);
    subLevers.forEach(sub => {
      Object.keys(SUB_LEVER_PARAMETERS).forEach(param => {
        setValue(`${leverId}${sub.id}${SUB_LEVER_PARAMETERS[param]}`, null);
        clearErrors(`${leverId}${sub.id}${SUB_LEVER_PARAMETERS[param]}`);
      });
    });
  };

  const handleConfirmation = () => {
    onConfirmDialogClose();
    const el = document.getElementById(`${leverId}-checkbox`);
    if (el) {
      el.click();
    }
    clearLeverData();
  };

  // Checking for available lever and sub-lever data, that will be lost in case of deselection
  const checkForAvailableData = () => {
    const allLeverFieldsKeys = [`${leverId}totalCo2Emissions`];
    subLevers.forEach(subLever => {
      Object.keys(SUB_LEVER_PARAMETERS).filter(el => el !== SUB_LEVER_PARAMETERS.totalCo2Saved).forEach(param => {
        allLeverFieldsKeys.push(`${leverId}${subLever.id}${param}`);
      });
    });
    const foundData = allLeverFieldsKeys.find(key => formValues[key] !== "" && formValues[key] !== null);
    return typeof foundData !== "undefined";
  };

  return (
    <Flex direction="column" gap={3} marginBottom={selected ? 10 : 2}>
      <Divider />
      <FormCheckBox
        {...register(`${leverId}selected`)}
        label={
          <Text fontSize="xl" fontWeight="semibold">
            {`${leverIndex + 1}. ${leverName}`}
          </Text>
        }
        errors={errors}
        control={control}
        controlProps={{
          id: `${leverId}-checkbox`,
          onClick: (e) => {
            if (selected) {
              // If checkbox is already selected, it is manually (not programmatically) clicked and
              // if there is any filled data => open confirmation dialog
              if (e.isTrusted && checkForAvailableData()) {
                e.preventDefault();
                onConfirmDialogOpen();
              } else {
                clearLeverData();
              }
            }
          }
        }}
      />
      {
        selected &&
        <>
          <Flex direction="column" gap={1}>
            <NumericFormInputGroup
              {...register(`${leverId}totalCo2Emissions`, {
                required: selected ? t("errors.required") : false,
                pattern: VALIDATION_PATTERNS.POSITIVE_NUMBER
              })}
              label={`${t("decarbonization.leversParametersModal.levers.totalEmissions")} *`}
              errors={errors}
              type="number"
              width="150px"
              addonText={translateSubElementString(`measures.tCO2e`)}
              title={formValues[`${leverId}totalCo2Emissions`]}
            />
          </Flex>
          {subLevers.map((subLever, index) => {
            return <SubLever
              key={`${leverId}-${subLever.id}`}
              leverId={leverId}
              baseYear={baseYear}
              subLeverId={subLever.id}
              subLeverName={subLever.name}
              subLeverIndex={index}
              register={register}
              errors={errors}
              watch={watch}
            />;
          })}
        </>
      }
      <ConfirmationDialog
        isOpen={isConfirmDialogOpen}
        onClose={onConfirmDialogClose}
        onConfirm={handleConfirmation}
        headerText={t("decarbonization.leversParametersModal.confirmation.header")}
        confirmationText={t("decarbonization.leversParametersModal.confirmation.question")}
      />
    </Flex>
  );
}

export default Lever;